import { polygonsOf, TIMEZONES } from './timezones';

function pointInRingPlanar(lon: number, lat: number, ring: number[][]) {
  let inside = false;
  for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
    const [xi, yi] = ring[i];
    const [xj, yj] = ring[j];
    if (
      yi > lat !== yj > lat &&
      lon < ((xj - xi) * (lat - yi)) / (yj - yi) + xi
    ) {
      inside = !inside;
    }
  }
  return inside;
}

function pointInPolygonPlanar(lon: number, lat: number, rings: number[][][]) {
  if (!rings[0] || !pointInRingPlanar(lon, lat, rings[0])) return false;
  for (let k = 1; k < rings.length; k++)
    if (pointInRingPlanar(lon, lat, rings[k])) return false;
  return true;
}

export function zoneAt(lat: number, lon: number): number | null {
  for (const z of TIMEZONES) {
    for (const rings of polygonsOf(z))
      if (pointInPolygonPlanar(lon, lat, rings)) return z.zone;
  }
  return null;
}
